/* tslint:disable */
/* eslint-disable */

import { Mockup } from "./self-service.interceptor";

export const MOCKUP_DATA: Mockup = {
  "$schema": "./self-service.schema.json",
  "delay": 1500,
  "paths": {
    "/elements/my-premises-select": {
      "GET": [
        {
          "id": "1",
          "name": "Vattenledningsvägen 23H",
          "zipCode": "126 33",
          "city": "Hägersten",
          "serviceGroup": "Electricity"
        },
        {
          "id": "2",
          "name": "Villavägen 6",
          "zipCode": "168 53",
          "city": "Bromma",
          "serviceGroup": "Heat"
        },
        {
          "id": "3",
          "name": "Stengatan 98",
          "zipCode": "668 30",
          "city": "Sundsvall",
          "serviceGroup": "Unknown"
        }
      ]
    },
    "/elements/my-widgets-premise-details/premises/:premiseId": {
      "GET": [
        {
          "_premiseId": "1",
          "customerId": "1000071093",
          "premiseSiteName": "Dragontorpsvägen 7",
          "premiseId": "AKB735999114009345270",
          "premiseServiceGroup": "Electricity"
        },
        {
          "_premiseId": "2",
          "customerId": "1000071222",
          "premiseSiteName": "Vikavägen 7",
          "premiseId": "AKB735999435609345270",
          "premiseServiceGroup": "Heat"
        },
        {
          "_premiseId": "3",
          "customerId": "1000071467",
          "premiseSiteName": "Valhallaskogen 3",
          "premiseId": "AKB735999114009345270",
          "premiseServiceGroup": "Unknown"
        }
      ]
    },
    "/elements/my-widgets-invoice-overview/premises/:premiseId": {
      "GET": [
        {
          "_premiseId": "1",
          "amount": 298.58,
          "status": "Unpaid"
        },
        {
          "_premiseId": "2",
          "amount": 428.32,
          "status": "PassedDueDate"
        },
        {
          "_premiseId": "3",
          "amount": 4325.55,
          "status": "Paid"
        }
      ]
    },
    "/elements/my-widgets-consumption-overview/premises/:premiseId": {
      "GET": [
        {
          "_premiseId": "1",
          "year": 2020,
          "month": 4,
          "consumption": {
            "value": 143,
            "unit": "KWH"
          },
          "percentageChangeComparedToSameMonthPreviousYear": -1.4,
          "serviceGroup": "Electricity"
        },
        {
          "_premiseId": "2",
          "year": 2019,
          "month": 12,
          "consumption": {
            "value": 143,
            "unit": "KWH"
          },
          "percentageChangeComparedToSameMonthPreviousYear": 10,
          "serviceGroup": "Heat"
        },
        {
          "_premiseId": "3",
          "year": 2019,
          "month": 12,
          "consumption": {
            "value": 143,
            "unit": "KWH"
          },
          "percentageChangeComparedToSameMonthPreviousYear": 10,
          "serviceGroup": "Heat"
        }
      ]
    },
    "/elements/my-widgets-contract-price/premises/:premiseId": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "1",
          "energyPrice": {
            "value": 12.22,
            "unit": "SWEDISH_ORE/KWH"
          },
          "contractType": "Heat",
          "contractName": "Värme – Villa"
        },
        {
          "$array": true,
          "_premiseId": "2",
          "highElectricityPrice": {
            "value": 10.35,
            "unit": "SWEDISH_ORE/KWH"
          },
          "lowElectricityPrice": {
            "value": 9.05,
            "unit": "SWEDISH_ORE/KWH"
          },
          "contractType": "TimeTariffPrice",
          "contractName": "Tidstariff"
        },
        {
          "$array": true,
          "_premiseId": "3",
          "contractType": "UnknownElectricityContract",
          "contractName": "Okändt elektricitetskontrakt"
        }
      ]
    },
    "/elements/flows-energy-source-select-renewal-section": {
      "GET": [
        {
          "_premiseId": "1",
          "energySource": "Water",
          "energySourcePriceExVat": {
            "value": 1,
            "unit": "SWEDISH_ORE/KWH"
          }
        },
        {
          "energySource": "Wind",
          "energySourcePriceExVat": {
            "value": 2.52,
            "unit": "SWEDISH_ORE/KWH"
          },
          "_premiseId": "1"
        },
        {
          "energySource": "Nuclear",
          "energySourcePriceExVat": {
            "value": -1,
            "unit": "SWEDISH_ORE/KWH"
          },
          "_premiseId": "1"
        },
        {
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "_premiseId": "1"
        }
      ]
    },
    "/elements/flows-energy-source-select-acquisition-section": {
      "GET": [
        {
          "_callerId": "1",
          "_customerType": "SME",
          "energySource": "Water",
          "energySourcePriceExVat": {
            "value": 1,
            "unit": "SWEDISH_ORE/KWH"
          }
        },
        {
          "_callerId": "1",
          "_customerType": "SME",
          "energySource": "Wind",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          }
        },
        {
          "_callerId": "1",
          "_customerType": "SME",
          "energySource": "Nuclear",
          "energySourcePriceExVat": {
            "value": 2,
            "unit": "SWEDISH_ORE/KWH"
          }
        },
        {
          "_callerId": "1",
          "_customerType": "SME",
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 2,
            "unit": "SWEDISH_ORE/KWH"
          }
        }
      ]
    },
    "/elements/flows-product-select-option/acquisition/products/:productId": {
      "GET": [
        {
          "_productId": "CompanyFixed3Years",
          "electricityPriceTotalExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 200,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 295,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceDiscountExVat": {
            "value": 95,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed3Years",
          "productName": "Rådgivningsavtal med fast elpris 3 år (har rtc rabatt)",
          "isRecommended": true
        },
        {
          "_productId": "CompanyFixed2Years",
          "electricityPriceTotalExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 195,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 195,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed2Years",
          "productName": "Rådgivningsavtal med fast elpris 2 år (ej rtc rabatt)",
          "isRecommended": false
        },
        {
          "_productId": "CompanyFixed6Months",
          "electricityPriceTotalExVat": {
            "value": 37.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 37.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.44,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med fast elpris 6 månader",
          "isRecommended": false
        },
        {
          "_productId": "CompanyFixed1Years",
          "electricityPriceTotalExVat": {
            "value": 36.5,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.5,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 125,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 125,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med fast elpris 1 år",
          "isRecommended": false
        },
        {
          "_productId": "CompanyVariableRate",
          "electricityPriceTotalExVat": {
            "value": 36.15,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 29.98,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 10,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "electricityCertificateExVat": {
            "value": 2.17,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 36.42,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med rörligt elpris",
          "isRecommended": false
        },
        {
          "_productId": "Failed",
          "electricityPriceTotalExVat": {
            "value": 36.15,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 29.98,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 10,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityCertificateExVat": {
            "value": 2.17,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 36.42,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "This matching product is used to develop an order that will return a mocked orderStatus FAILED in flows-submit-renewal-section",
          "isRecommended": false
        }
      ]
    },
    "/elements/flows-product-select-option/renewal/products/:productId": {
      "GET": [
        {
          "_productId": "CompanyFixed3Years",
          "electricityPriceTotalExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 200,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 295,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceDiscountExVat": {
            "value": 95,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed3Years",
          "productName": "Rådgivningsavtal med fast elpris 3 år (har rtc rabatt)",
          "isRecommended": true
        },
        {
          "_productId": "CompanyFixed2Years",
          "electricityPriceTotalExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.6,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 195,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 195,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed2Years",
          "productName": "Rådgivningsavtal med fast elpris 2 år (ej rtc rabatt)",
          "isRecommended": false
        },
        {
          "_productId": "CompanyFixed6Months",
          "electricityPriceTotalExVat": {
            "value": 37.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 37.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.44,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med fast elpris 6 månader",
          "isRecommended": false
        },
        {
          "_productId": "CompanyFixed1Years",
          "_premiseId": "UPP1234567890",
          "_energySource": "Mix",
          "electricityPriceTotalExVat": {
            "value": 36.5,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 36.5,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 125,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 125,
            "unit": "SWEDISH_KRONA"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 32.43,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med fast elpris 1 år",
          "isRecommended": false
        },
        {
          "_productId": "CompanyVariableRate",
          "electricityPriceTotalExVat": {
            "value": 36.15,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 29.98,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 10,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "electricityCertificateExVat": {
            "value": 2.17,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 36.42,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "Rådgivningsavtal med rörligt elpris",
          "isRecommended": false
        },
        {
          "_productId": "Failed",
          "electricityPriceTotalExVat": {
            "value": 36.15,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 29.98,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 10,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityCertificateExVat": {
            "value": 2.17,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "estimatedMonthlyCostExVat": {
            "value": 36.42,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productName": "This matching product is used to develop an order that will return a mocked orderStatus FAILED in flows-submit-renewal-section",
          "isRecommended": false
        }
      ]
    },
    "/elements/flows-acquisition-business-sweden-checkout/products/:productId": {
      "GET": [
        {
          "_productId": "CompanyVariableRate",
          "electricityPriceTotalExVat": {
            "value": 58.18,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 53.35,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 1,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountExVat": {
            "value": 1,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "electricityCertificateExVat": {
            "value": 1.83,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA"
          },
          "fixedFeeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "estimatedMonthlyCostExVat": {
            "value": 598.53,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyVariableRate",
          "productType": "SpotPriceElectricity",
          "productName": "Rörligt elpris",
          "contractStartDate": 1620086400,
          "contractEndDate": 1641600000
        },
        {
          "_productId": "CompanyFixed3Years",
          "electricityPriceTotalExVat": {
            "value": 36.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 40.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 745,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceDiscountExVat": {
            "value": 745,
            "unit": "SWEDISH_KRONA"
          },
          "electricityPriceDiscountExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountDuration": {
            "value": 36,
            "unit": "MONTHS"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA"
          },
          "fixedFeeDiscountDuration": {
            "value": 36,
            "unit": "MONTHS"
          },
          "estimatedMonthlyCostExVat": {
            "value": 378.58,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed3Years",
          "productType": "FixedPriceElectricity",
          "productName": "Fast elpris 3 år",
          "contractStartDate": 1620086400,
          "contractEndDate": 1628899200
        }
      ]
    },
    "/elements/flows-move-business-sweden-checkout/products/:productId": {
      "GET": [
        {
          "_productId": "CompanyVariableRate",
          "electricityPriceTotalExVat": {
            "value": 58.18,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 53.35,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceIsValidForMonth": 1,
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountExVat": {
            "value": 1,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceSurchargeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "electricityCertificateExVat": {
            "value": 1.83,
            "unit": "SWEDISH_ORE/KWH"
          },
          "isRightToChangeAvailable": false,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountExVat": {
            "value": 432,
            "unit": "SWEDISH_KRONA"
          },
          "fixedFeeDiscountDuration": {
            "value": 6,
            "unit": "MONTHS"
          },
          "estimatedMonthlyCostExVat": {
            "value": 598.53,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyVariableRate",
          "productType": "SpotPriceElectricity",
          "productName": "Rörligt elpris",
          "contractStartDate": 1620086400,
          "contractEndDate": 1641600000
        },
        {
          "_productId": "CompanyFixed3Years",
          "electricityPriceTotalExVat": {
            "value": 36.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceExVat": {
            "value": 40.8,
            "unit": "SWEDISH_ORE/KWH"
          },
          "rightToChangePriceTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceExVat": {
            "value": 745,
            "unit": "SWEDISH_KRONA"
          },
          "rightToChangePriceDiscountExVat": {
            "value": 745,
            "unit": "SWEDISH_KRONA"
          },
          "electricityPriceDiscountExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountDuration": {
            "value": 36,
            "unit": "MONTHS"
          },
          "isRightToChangeAvailable": true,
          "energySource": "Mix",
          "energySourcePriceExVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountExVat": {
            "value": 384,
            "unit": "SWEDISH_KRONA"
          },
          "fixedFeeDiscountDuration": {
            "value": 36,
            "unit": "MONTHS"
          },
          "estimatedMonthlyCostExVat": {
            "value": 378.58,
            "unit": "SWEDISH_KRONA/MONTH"
          },
          "productId": "CompanyFixed3Years",
          "productType": "FixedPriceElectricity",
          "productName": "Fast elpris 3 år",
          "contractStartDate": 1620086400,
          "contractEndDate": 1628899200
        }
      ]
    },
    "/elements/flows-premises-select/renewal": {
      "GET": [
        {
          "id": "UPN735999100001143334",
          "name": "Evenemangsgatan 1",
          "postalCode": "168 53",
          "postalTown": "Bromma",
          "premiseCampaignRemainingDays": {
            "value": 0,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614347869
        },
        {
          "id": "UMA735999101100453744",
          "name": "Arenavägen 1",
          "postalCode": "756 54",
          "postalTown": "UPPSALA",
          "premiseCampaignRemainingDays": {
            "value": 1,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614434269
        },
        {
          "id": "EKG735999114010270776",
          "name": "Evenemangsgatan 12",
          "postalCode": "168 53",
          "postalTown": "Bromma",
          "premiseCampaignRemainingDays": {
            "value": 2,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614520669
        },
        {
          "id": "DAD735999100053227983",
          "name": "Arenavägen 1",
          "postalCode": "213 45",
          "postalTown": "New York",
          "premiseCampaignRemainingDays": {
            "value": 3,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614607069
        },
        {
          "id": "FLE735999100054145255",
          "name": "Arenavägen 14",
          "postalCode": "756 54",
          "postalTown": "UPPSALA",
          "premiseCampaignRemainingDays": {
            "value": 4,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614693469
        },
        {
          "id": "MAI735999182001132402",
          "name": "Sven Botvids Allé 24",
          "postalCode": "66 68",
          "postalTown": "DO",
          "premiseCampaignRemainingDays": {
            "value": 5,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1614779869
        },
        {
          "id": "SHD735999100000096365",
          "name": "Evenemangsgatan 1",
          "postalCode": "756 54",
          "postalTown": "UPPSALA",
          "premiseCampaignRemainingDays": {
            "value": 6,
            "unit": "DAYS_REMAINING"
          },
          "premiseCampaignToDate": 1644192000
        }
      ]
    },
    "/elements/flows-premise-contract-summary/premises/:premiseId": {
      "GET": [
        {
          "_premiseId": "UPP1234567890",
          "streetName": "Äggelundavägen 2 A",
          "postalCode": "123 45",
          "postalTown": "Växjö",
          "contractName": "Fast elpris 3 år",
          "contractStartDate": 1577836800,
          "contractEndDate": 1609372800,
          "electricityPriceTotalExVat": {
            "value": 64.3,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 336,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "invoicesPerYear": {
            "value": 12,
            "unit": "INVOICES_PER_YEAR"
          }
        }
      ]
    },
    "/elements/my-contact-notification-dialog/customer/contact-information": {
      "GET": [
        {
          "mobileNumber": "0765432",
          "emailAddress": "asdf@ads.com",
          "displayNotification": true
        }
      ],
      "PUT": [
        {
          "mobileNumber": "0765432",
          "emailAddress": "asdf@ads.com"
        }
      ]
    },
    "/elements/flows-acquisition-business-sweden-checkout/orders": {
      "POST": [
        {
          "orderId": "VAT28",
          "orderStatus": "SUCCESS"
        }
      ]
    },
    "/elements/flows-move-business-sweden-checkout/orders": {
      "POST": [
        {
          "orderId": "VAT28",
          "orderStatus": "SUCCESS"
        }
      ]
    },
    "/elements/postal-code-grid-area/grid-areas/:gridArea": {
      "GET": [
        {
          "_gridArea": "STH",
          "gridArea": "STH",
          "energyArea": "SN3"
        },
        {
          "_gridArea": "MMO",
          "gridArea": "MMO",
          "energyArea": "SN4"
        }
      ]
    },
    "/elements/postal-code-grid-area/postal-codes/:postalCode": {
      "GET": [
        {
          "_postalCode": "12345",
          "postalTown": "Stockholm",
          "gridArea": "STH",
          "energyArea": "SN3"
        },
        {
          "_postalCode": "22222",
          "postalTown": "Malmö",
          "gridArea": "",
          "energyArea": "SN4"
        }
      ]
    },
    "/elements/flows-contract-details-section/premises/:premiseId": {
      "GET": [
        {
          "_premiseId": "UPP1234567890",
          "estimatedYearlyConsumption": {
            "value": 6853,
            "unit": "KWH"
          },
          "priceValidStartDate": 1644192000
        }
      ]
    },
    "/elements/my-profile-communication-settings/customer/communication-settings": {
      "GET": [
        {
          "useEmailForAdvertising": true,
          "useEmailForContractInfo": true,
          "useEmailForNewsLetter": true,
          "useMobileForSalesInfo": true,
          "emailAddress": "abc@432.com",
          "mobileNumber": "08765432"
        }
      ],
      "PUT": [
        {
          "useEmailForAdvertising": true,
          "useEmailForContractInfo": true,
          "useEmailForNewsLetter": true,
          "useMobileForSalesInfo": true,
          "emailAddress": "def@567.com",
          "mobileNumber": "086644482"
        }
      ]
    },
    "/elements/my-profile-details-view/customer/profile-information": {
      "GET": [
        {
          "customerNumber": "ABC1234567890",
          "phoneNumber": "087654321",
          "firstName": "Adam",
          "lastName": "Bertilsson",
          "streetName": "Äggelundavägen 2 A",
          "postalCode": "123 45",
          "postalTown": "Växjö"
        }
      ],
      "PATCH": [
        {
          "phoneNumber": "0707654321"
        }
      ]
    },
    "/elements/my-contracts-view/premises/:premiseId": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "1",
          "electricityPriceExVat": {
            "value": 82.9,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceVat": {
            "value": 20.73,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalIncVat": {
            "value": 103.63,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountStartDate": 1484870400,
          "electricityPriceDiscountEndDate": 1485870400,
          "fixedFeeTotalIncVat": {
            "value": 440,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountIncVat": {
            "value": 100,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeIncVat": {
            "value": 540,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "gridOwner": "Vattenfall Eldistribution AB",
          "gridArea": "HUV",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 1942,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Mixed",
          "contractStartDate": 1484870400,
          "contractName": "Anvisningsavtal",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "TariffPrice",
          "premiseSiteName": "Hamngatan 22 D  1302",
          "premiseId": "HUV735999100015954186",
          "isRenewable": true
        },
        {
          "$array": true,
          "_premiseId": "2",
          "electricityPriceExVat": {
            "value": 43.2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountExVat": {
            "value": 2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalExVat": {
            "value": 41.2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountStartDate": 1530403200,
          "electricityPriceDiscountEndDate": 1625011200,
          "fixedFeeTotalExVat": {
            "value": 240,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 240,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "customersOwnReference": "",
          "isRenewable": true,
          "gridOwner": "E.ON Energidistribution AB",
          "gridArea": "OGO",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 15296,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Mixed",
          "contractStartDate": 1530403200,
          "contractEndDate": 1625011200,
          "contractName": "Fast elpris 3 år",
          "invoicesPerYear": {
            "value": 4,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "FixedPriceSmallEnterprise",
          "premiseSiteName": "Drothemsgatan",
          "premiseId": "OGO735999114000009119"
        },
        {
          "$array": true,
          "_premiseId": "3",
          "electricityPriceExVat": {
            "value": 64.3,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalExVat": {
            "value": 65.82,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 336,
            "unit": "UNIT_UNKNOWN"
          },
          "fixedFeeDiscountExVat": {
            "value": 3,
            "unit": "UNIT_UNKNOWN"
          },
          "electricityPriceDiscountStartDate": 1484870400,
          "electricityPriceDiscountEndDate": 1485870400,
          "gridOwner": "E.ON Elnät Stockholm AB",
          "gridArea": "UPS",
          "energyArea": "SE3",
          "yearlyConsumption": {
            "value": 34427,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Wind",
          "energySourcePriceExVat": {
            "value": 1.52,
            "unit": "SWEDISH_ORE/KWH"
          },
          "contractStartDate": 1554076800,
          "contractEndDate": 1585612800,
          "contractName": "Fast elpris 1 år",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "FixedPriceSmallEnterprise",
          "premiseSiteName": "Äggelundavägen 2 A",
          "premiseId": "735999114009896437",
          "customersOwnReference": "abcd abcd abcd abcd abcde",
          "isRenewable": true
        },
        {
          "$array": true,
          "_premiseId": "HUV735999100015954186",
          "electricityPriceExVat": {
            "value": 82.9,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceVat": {
            "value": 20.73,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalIncVat": {
            "value": 103.63,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountStartDate": 1484870400,
          "electricityPriceDiscountEndDate": 1485870400,
          "fixedFeeTotalIncVat": {
            "value": 440,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountIncVat": {
            "value": 100,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeIncVat": {
            "value": 540,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "gridOwner": "Vattenfall Eldistribution AB",
          "gridArea": "HUV",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 1942,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Mixed",
          "contractStartDate": 1484870400,
          "contractName": "Anvisningsavtal",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "TariffPrice",
          "premiseSiteName": "Hamngatan 22 D  1302",
          "premiseId": "HUV735999100015954186",
          "isRenewable": true
        },
        {
          "$array": true,
          "_premiseId": "OGO735999114000009119",
          "electricityPriceExVat": {
            "value": 43.2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountExVat": {
            "value": 2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalExVat": {
            "value": 41.2,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceDiscountStartDate": 1530403200,
          "electricityPriceDiscountEndDate": 1625011200,
          "fixedFeeTotalExVat": {
            "value": 240,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeExVat": {
            "value": 240,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "customersOwnReference": "",
          "isRenewable": true,
          "gridOwner": "E.ON Energidistribution AB",
          "gridArea": "OGO",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 15296,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Mixed",
          "contractStartDate": 1530403200,
          "contractEndDate": 1625011200,
          "contractName": "Fast elpris 3 år",
          "invoicesPerYear": {
            "value": 4,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "FixedPriceSmallEnterprise",
          "premiseSiteName": "Drothemsgatan",
          "premiseId": "OGO735999114000009119"
        },
        {
          "$array": true,
          "_premiseId": "HUV735999100015954186",
          "electricityPriceExVat": {
            "value": 64.3,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalExVat": {
            "value": 65.82,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalExVat": {
            "value": 336,
            "unit": "UNIT_UNKNOWN"
          },
          "fixedFeeDiscountExVat": {
            "value": 3,
            "unit": "UNIT_UNKNOWN"
          },
          "electricityPriceDiscountStartDate": 1484870400,
          "electricityPriceDiscountEndDate": 1485870400,
          "gridOwner": "E.ON Elnät Stockholm AB",
          "gridArea": "UPS",
          "energyArea": "SE3",
          "yearlyConsumption": {
            "value": 34427,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Wind",
          "energySourcePriceExVat": {
            "value": 1.52,
            "unit": "SWEDISH_ORE/KWH"
          },
          "contractStartDate": 1554076800,
          "contractEndDate": 1585612800,
          "contractName": "Fast elpris 1 år",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "FixedPriceSmallEnterprise",
          "premiseSiteName": "Äggelundavägen 2 A",
          "premiseId": "735999114009896437",
          "customersOwnReference": "abcd abcd abcd abcd abcde",
          "isRenewable": true
        },
        {
          "$array": true,
          "_premiseId": "HUPP3013196",
          "tariff": "Värme - Villa",
          "energyPriceTotalIncVat": {
            "value": 834,
            "unit": "SWEDISH_KRONA/MWH"
          },
          "fixedFeeIncVat": {
            "value": 4047,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "warmWaterCostIncVat": {
            "value": 47.47,
            "unit": "SWEDISH_KRONA/CUBIC_METER"
          },
          "contractStartDate": 1577836800,
          "contractEndDate": 1609372800,
          "contractName": "Fjärrvärme",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "Heat",
          "premiseSiteName": "Gitarrvägen 23",
          "premiseId": "HUPP3013196"
        },
        {
          "$array": true,
          "_premiseId": "AKB735999114009345270",
          "electricityPriceSurchargeExVat": {
            "value": 4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityCertificateCostExVat": {
            "value": 3,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalIncVat": {
            "value": 0,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalIncVat": {
            "value": 540,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "fixedFeeDiscountIncVat": {
            "value": 0,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "contractStartDate": 1350432000,
          "contractName": "Rörligt elpris",
          "gridOwner": "E.ON Elnät AB",
          "energyArea": "SN3",
          "invoicesPerYear": {
            "value": 12,
            "unit": "INVOICES_PER_YEAR"
          },
          "yearlyConsumption": {
            "value": 20445,
            "unit": "KWH"
          },
          "rightToChange": false,
          "contractType": "SpotPrice",
          "energySource": "Wind",
          "premiseSiteName": "Dragontorpsvägen 7",
          "premiseId": "AKB735999114009345270"
        },
        {
          "$array": true,
          "_premiseId": "AKB735999114009345270",
          "lowElectricityPriceExVat": {
            "value": 41.4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "lowElectricityPriceVat": {
            "value": 10.35,
            "unit": "SWEDISH_ORE/KWH"
          },
          "lowElectricityPriceTotalIncVat": {
            "value": 51.75,
            "unit": "SWEDISH_ORE/KWH"
          },
          "highElectricityPriceExVat": {
            "value": 41.4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "highElectricityPriceVat": {
            "value": 10.35,
            "unit": "SWEDISH_ORE/KWH"
          },
          "highElectricityPriceTotalIncVat": {
            "value": 51.75,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeIncVat": {
            "value": 420,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "gridOwner": "Vattenfall Eldistribution AB",
          "gridArea": "DAD",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 6925,
            "unit": "KWH"
          },
          "rightToChange": true,
          "energySource": "Mixed",
          "contractStartDate": 1525824000,
          "contractEndDate": 1620432000,
          "contractName": "Fast elpris 3 år",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "TimeTariffPrice",
          "premiseSiteName": "Björkhaget 5",
          "premiseId": "DAD735999100053445271"
        },
        {
          "$array": true,
          "_premiseId": "UPP735999100057049772",
          "contractStartDate": 1227484800,
          "contractName": "Rörligt elpris",
          "invoicesPerYear": {
            "value": 6,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "UnknownElectricityContract",
          "premiseSiteName": "Gitarrvägen 23",
          "premiseId": "UPP735999100057049772"
        },
        {
          "$array": true,
          "_premiseId": "DRV735999100057606173",
          "electricityPriceExVat": {
            "value": 67,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceVat": {
            "value": 16.75,
            "unit": "SWEDISH_ORE/KWH"
          },
          "electricityPriceTotalIncVat": {
            "value": 83.75,
            "unit": "SWEDISH_ORE/KWH"
          },
          "fixedFeeTotalIncVat": {
            "value": 540,
            "unit": "SWEDISH_KRONA/YEAR"
          },
          "gridOwner": "Vattenfall Eldistribution AB",
          "gridArea": "DRV",
          "energyArea": "SN3",
          "yearlyConsumption": {
            "value": 18948,
            "unit": "KWH"
          },
          "rightToChange": false,
          "energySource": "Mixed",
          "contractStartDate": 1577836800,
          "contractName": "Vintersäkring",
          "invoicesPerYear": {
            "value": 12,
            "unit": "INVOICES_PER_YEAR"
          },
          "contractType": "WinterInsurance",
          "premiseSiteName": "Höglidsvägen 3 B",
          "premiseId": "DRV735999100057606173"
        }
      ]
    },
    "/elements/flows-product-addons-section/customer/contact-information": {
      "GET": [
        {
          "phoneNumber": "",
          "emailAddress": ""
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/consumption": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "consumption": {
            "value": 0.424,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "consumption": {
            "value": 0.455,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "consumption": {
            "value": 0.432,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "consumption": {
            "value": 0.546,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "consumption": {
            "value": 0.697,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "consumption": {
            "value": 0.7,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "consumption": {
            "value": 0.696,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "consumption": {
            "value": 0.789,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "consumption": {
            "value": 0.695,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "consumption": {
            "value": 0.754,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "consumption": {
            "value": 0.695,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "consumption": {
            "value": 0.694,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "consumption": {
            "value": 0.798,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "consumption": {
            "value": 0.852,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "consumption": {
            "value": 0.709,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "consumption": {
            "value": 0.703,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "consumption": {
            "value": 0.877,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "consumption": {
            "value": 0.965,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "consumption": {
            "value": 1.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "consumption": {
            "value": 1.456,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "consumption": {
            "value": 1.132,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "consumption": {
            "value": 1.042,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "consumption": {
            "value": 0.845,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "consumption": {
            "value": 0.702,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 1,
          "consumption": {
            "value": 11.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 2,
          "consumption": {
            "value": 8.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 3,
          "consumption": {
            "value": 9.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 4,
          "consumption": {
            "value": 7.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 5,
          "consumption": {
            "value": 11.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 6,
          "consumption": {
            "value": 12.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "day": 7,
          "consumption": {
            "value": 15.123,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 1525,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1445,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1410,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 1048,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 656,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 484,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 778,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 1045,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 1185,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1425,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Consumed",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 985,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 1425,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2021,
          "month": 12,
          "consumption": {
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1225,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1045,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1010,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 648,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 256,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 678,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 645,
            "unit": "KWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Invoiced",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 445,
            "unit": "KWH"
          }
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/cost": {
      "GET": [
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 0,
          "price": {
            "value": 67.28,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.858,
            "unit": "KWH"
          },
          "cost": {
            "value": 125.00624,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 1,
          "price": {
            "value": 63.1,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.949,
            "unit": "KWH"
          },
          "cost": {
            "value": 122.9819,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 2,
          "price": {
            "value": 60.76,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 2.128,
            "unit": "KWH"
          },
          "cost": {
            "value": 129.29728,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 3,
          "price": {
            "value": 61.55,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.923,
            "unit": "KWH"
          },
          "cost": {
            "value": 118.36065,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 4,
          "price": {
            "value": 61.09,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.9,
            "unit": "KWH"
          },
          "cost": {
            "value": 116.071,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 5,
          "price": {
            "value": 61.29,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.851,
            "unit": "KWH"
          },
          "cost": {
            "value": 113.44779,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 6,
          "price": {
            "value": 59.91,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 2.244,
            "unit": "KWH"
          },
          "cost": {
            "value": 134.43804,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 7,
          "price": {
            "value": 71.85,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 2.422,
            "unit": "KWH"
          },
          "cost": {
            "value": 174.0207,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 8,
          "price": {
            "value": 81.95,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 2.557,
            "unit": "KWH"
          },
          "cost": {
            "value": 209.54615,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 9,
          "price": {
            "value": 94.56,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.275,
            "unit": "KWH"
          },
          "cost": {
            "value": 120.564,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 10,
          "price": {
            "value": 81.34,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.613,
            "unit": "KWH"
          },
          "cost": {
            "value": 131.20142,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 11,
          "price": {
            "value": 76.44,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.061,
            "unit": "KWH"
          },
          "cost": {
            "value": 81.10284,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 12,
          "price": {
            "value": 69.21,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.594,
            "unit": "KWH"
          },
          "cost": {
            "value": 110.32074,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 13,
          "price": {
            "value": 65.91,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.213,
            "unit": "KWH"
          },
          "cost": {
            "value": 79.94883,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 14,
          "price": {
            "value": 58.7,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.235,
            "unit": "KWH"
          },
          "cost": {
            "value": 72.4945,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 15,
          "price": {
            "value": 62.75,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.247,
            "unit": "KWH"
          },
          "cost": {
            "value": 78.24925,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 16,
          "price": {
            "value": 68.66,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.049,
            "unit": "KWH"
          },
          "cost": {
            "value": 72.02434,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 17,
          "price": {
            "value": 80.19,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.313,
            "unit": "KWH"
          },
          "cost": {
            "value": 105.28947,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 18,
          "price": {
            "value": 86.36,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 0.891,
            "unit": "KWH"
          },
          "cost": {
            "value": 76.94676,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 19,
          "price": {
            "value": 86.48,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.411,
            "unit": "KWH"
          },
          "cost": {
            "value": 122.02328,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 20,
          "price": {
            "value": 80.88,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.271,
            "unit": "KWH"
          },
          "cost": {
            "value": 102.79848,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 21,
          "price": {
            "value": 73.45,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.33,
            "unit": "KWH"
          },
          "cost": {
            "value": 97.6885,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 22,
          "price": {
            "value": 67.31,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.947,
            "unit": "KWH"
          },
          "cost": {
            "value": 131.05257,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2023,
          "month": 4,
          "day": 1,
          "hour": 23,
          "price": {
            "value": 59.65,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 1.541,
            "unit": "KWH"
          },
          "cost": {
            "value": 91.92065,
            "unit": "SWEDISH_ORE"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 1,
          "price": {
            "value": 124.34,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 33.49,
            "unit": "KWH"
          },
          "cost": {
            "value": 41.79,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 2,
          "price": {
            "value": 44.88,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 29.83,
            "unit": "KWH"
          },
          "cost": {
            "value": 13.55,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 3,
          "price": {
            "value": 76.1,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 31.83,
            "unit": "KWH"
          },
          "cost": {
            "value": 25.32,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 4,
          "price": {
            "value": 102.44,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 41.5,
            "unit": "KWH"
          },
          "cost": {
            "value": 41.15,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 5,
          "price": {
            "value": 175.79,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 44.33,
            "unit": "KWH"
          },
          "cost": {
            "value": 0,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 6,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 48.12,
            "unit": "KWH"
          },
          "cost": {
            "value": 105.61,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 7,
          "price": {
            "value": 150,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 41.23,
            "unit": "KWH"
          },
          "cost": {
            "value": 61.18,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 8,
          "price": {
            "value": 196.44,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 33.64,
            "unit": "KWH"
          },
          "cost": {
            "value": 75.02,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 9,
          "price": {
            "value": 39.72,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "value": 21.98,
            "unit": "KWH"
          },
          "cost": {
            "value": 67.18,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 10,
          "price": {
            "value": 22.59,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 11,
          "price": {
            "value": 40.4,
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 12,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 13,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 14,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 15,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 16,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 17,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 18,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 19,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 20,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 21,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 22,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 23,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 24,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 25,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 26,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 27,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 28,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 29,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 30,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2023,
          "month": 3,
          "day": 31,
          "price": {
            "unit": "SWEDISH_ORE/KWH"
          },
          "consumption": {
            "unit": "KWH"
          },
          "cost": {
            "unit": "SWEDISH_KRONA"
          }
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/temperature": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "temperature": {
            "value": -3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "temperature": {
            "value": -4,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "temperature": {
            "value": -6,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "temperature": {
            "value": -3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "temperature": {
            "value": -2,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "temperature": {
            "value": -2,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "temperature": {
            "value": -1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "temperature": {
            "value": 0,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "temperature": {
            "value": 2,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "temperature": {
            "value": 3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "temperature": {
            "value": 4,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "temperature": {
            "value": 3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "temperature": {
            "value": 4,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "temperature": {
            "value": 5,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "temperature": {
            "value": 4,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "temperature": {
            "value": 3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "temperature": {
            "value": 3,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "temperature": {
            "value": 1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "temperature": {
            "value": 0,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "temperature": {
            "value": 0,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "temperature": {
            "value": -1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "temperature": {
            "value": 0,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "temperature": {
            "value": 0,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "temperature": {
            "value": -1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 1,
          "temperature": {
            "value": 5.1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 2,
          "temperature": {
            "value": 0.1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 3,
          "temperature": {
            "value": -1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 4,
          "temperature": {
            "value": 2,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 5,
          "temperature": {
            "value": 2.1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 6,
          "temperature": {
            "value": 1,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "year": 2022,
          "month": 1,
          "day": 7,
          "temperature": {
            "value": 1.8,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 1,
          "temperature": {
            "value": -3,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 2,
          "temperature": {
            "value": -2,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 3,
          "temperature": {
            "value": 3,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 4,
          "temperature": {
            "value": 11,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 5,
          "temperature": {
            "value": 16,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 6,
          "temperature": {
            "value": 22,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 7,
          "temperature": {
            "value": 25,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 8,
          "temperature": {
            "value": 18,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 9,
          "temperature": {
            "value": 16,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 10,
          "temperature": {
            "value": 12,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 11,
          "temperature": {
            "value": 5,
            "unit": "CELSIUS"
          },
          "year": 2022
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Monthly",
          "month": 12,
          "temperature": {
            "unit": "CELSIUS"
          },
          "year": 2022
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/electricity-start-date": {
      "GET": [
        {
          "$value": 1609459200,
          "_premiseId": "*"
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/electricity-history": {
      "GET": [
        {
          "_premiseId": "*",
          "_resolution": "Hourly",
          "startDate": 1603787234,
          "endDate": 1698302110,
          "unavailablePeriods": [
            {
              "fromDate": 1604471710,
              "toDate": 1613111710
            },
          ]
        },
        {
          "_premiseId": "*",
          "_resolution": "Daily",
          "startDate": 1628855970.0,
          "endDate": 1723420800.0,
          "unavailablePeriods": [
              {
                  "fromDate": 1628855970.0,
                  "toDate": 1714780800.0
              }
          ]
        },
        {
          "_premiseId": "*",
          "_resolution": "Weekly",
          "startDate": 1603787205,
          "endDate": 1698302110,
          "unavailablePeriods": [
            {
              "fromDate": 1604471710,
              "toDate": 1613111710
            },
          ]
        },
        {
          "_premiseId": "*",
          "_resolution": "Monthly",
          "startDate": 1578873600.0,
          "endDate": 1723420800.0,
          "unavailablePeriods": []
        },
        {
          "_premiseId": "*",
          "_resolution": "Yearly",
          "startDate": 1556755200,
          "endDate": 1698302110,
          "unavailablePeriods": [
            {
              "fromDate": 1581662110,
              "toDate": 1646894110
            }
          ]
        },
      ]
    },
    "/elements/my-consumption/premises/:premiseId/resolutions": {
      "GET": [
        {
          "_premiseId": "1",
          "consumptionResolutions": [
            "Hourly",
            "Daily",
            "Weekly",
            "Monthly",
            "Yearly"
          ],
          "costResolutions": [
            "Hourly",
            "Daily"
          ]
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/is-consuming-electricity": {
      "GET": [
        {
          "$value": true,
          "_premiseId": "1"
        },
        {
          "$value": true,
          "_premiseId": "2"
        },
        {
          "$value": true,
          "_premiseId": "3"
        },
        {
          "$value": false,
          "_premiseId": "4"
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/grid-owner": {
      "GET": [
        {
          "$value": "Vattenfall AB",
          "_premiseId": "1"
        },
        {
          "$value": "Elevio AB",
          "_premiseId": "2"
        },
        {
          "$value": "EON AB",
          "_premiseId": "3"
        },
        {
          "$value": "Devops Online AB",
          "_premiseId": "4"
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/energy-area": {
      "GET": [
        {
          "$value": "SN3",
          "_premiseId": "*"
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/trading-fee-start-date": {
      "GET": [
        {
          "$value": 1654034400,
          "_premiseId": "*"
        }
      ]
    },
    "/elements/my-profile/contact-details": {
      "GET": [
        {
          "customerId": "1000114826",
          "name": "Nils-Erik Svensson Johansson",
          "streetName": "Gullrisvägen 1",
          "floor": "",
          "postalCode": "982 35",
          "postalTown": "Gällivare",
          "country": "Sverige",
          "emailAddress": "conny.finne@vattenfall.com",
          "mobileNumber": "020820000",
          "useEmailCommunication": false,
          "useMobileCommunication": false
        }
      ]
    },
    "/elements/my-profile/contact-details/email/email-address": {
      "PUT": [
        {
          "emailAddress": "hello@hello.com",
          "useEmailCommunication": true
        }
      ]
    },
    "/elements/my-profile/contact-details/mobile/number": {
      "PUT": [
        {
          "mobileNumber": "0735554445",
          "useMobileCommunication": true
        }
      ]
    },
    "/elements/my-profile/contact-details/email/subscribe": {
      "PUT": [
        {
          "useEmailCommunication": false
        }
      ]
    },
    "/elements/my-profile/contact-details/mobile/subscribe": {
      "PUT": [
        {
          "useMobileCommunication": false
        }
      ]
    },
    "/elements/my-profile/invoice-settings": {
      "GET": [
        {
          "_premiseId": "1",
          "isMainAddress": false,
          "streetName": "Drottninggatan 45",
          "postalCode": "111 21",
          "postalTown": "Stockholm",
          "country": "SE",
          "invoiceInterval": "Månadsvis",
          "invoiceDeliveryMethod": "Pappersfaktura",
          "careOfAddress": "Lars Andersson",
          "isAutogiroActive": false,
          "hasSeveralPremises": false,
          "isInvoiceAddressReadOnly": false,
          "isPaymentTypeReadOnly": false,
          "allowedInvoiceIntervals": [
            {
              "invoiceIntervalId": "M",
              "name": "Månadsvis"
            },
            {
              "invoiceIntervalId": "B",
              "name": "Varannan månad"
            },
            {
              "invoiceIntervalId": "Q",
              "name": "Kvartalsvis"
            },
            {
              "invoiceIntervalId": "Y",
              "name": "Årsvis"
            }
          ]
        },
        {
          "_premiseId": "2",
          "isMainAddress": false,
          "streetName": "Testing 2nd street",
          "postalCode": "123 45",
          "postalTown": "Gotenberg",
          "country": "SE",
          "invoiceInterval": "Månadsvis",
          "invoiceDeliveryMethod": "E-faktura",
          "careOfAddress": "Nani",
          "isAutogiroActive": false,
          "hasSeveralPremises": false,
          "isInvoiceAddressReadOnly": false,
          "allowedInvoiceIntervals": [
            {
              "invoiceIntervalId": "M",
              "name": "Månadsvis"
            },
            {
              "invoiceIntervalId": "B",
              "name": "Varannan månad"
            },
            {
              "invoiceIntervalId": "Q",
              "name": "Kvartalsvis"
            },
            {
              "invoiceIntervalId": "Y",
              "name": "Årsvis"
            }
          ]
        },
        {
          "_premiseId": "3",
          "isMainAddress": false,
          "streetName": "Manhattan 42nd street",
          "postalCode": "456 789",
          "postalTown": "New York",
          "country": "SE",
          "invoiceInterval": "Månadsvis",
          "invoiceDeliveryMethod": "E-faktura",
          "careOfAddress": "Tim David",
          "isAutogiroActive": false,
          "hasSeveralPremises": false,
          "isInvoiceAddressReadOnly": false,
          "allowedInvoiceIntervals": [
            {
              "invoiceIntervalId": "M",
              "name": "Månadsvis"
            },
            {
              "invoiceIntervalId": "B",
              "name": "Varannan månad"
            },
            {
              "invoiceIntervalId": "Q",
              "name": "Kvartalsvis"
            },
            {
              "invoiceIntervalId": "Y",
              "name": "Årsvis"
            }
          ]
        }
      ],
      "POST": [
        {
          "careOfAddress": "Lars Andersson",
          "country": "SE",
          "postalCode": "111 21",
          "postalTown": "Server",
          "streetName": "ServerResponse 45"
        }
      ]
    },
    "/elements/my-profile/invoice-settings/main-address": {
      "GET": [
        {
          "isMainAddress": true,
          "streetName": "MainAdressgatan 23",
          "postalCode": "111 23",
          "postalTown": "Stockholm",
          "country": "SE",
          "careOfAddress": "Lars Andersson"
        }
      ]
    },
    "/elements/my-profile/invoice-settings/invoice-interval": {
      "PUT": [
        {
          "invoiceIntervalId": "Y",
          "name": "Årsvis",
          "useForAllPremises": false,
          "premiseId": null
        }
      ]
    },
    "/elements/my-profile/invoice-settings/payment/banks": {
      "GET": [
        {
          "bankName": "Danske Bank",
          "bankId": "0010"
        },
        {
          "bankName": "Handelsbanken",
          "bankId": "0020"
        },
        {
          "bankName": "ICA Banken",
          "bankId": "0030"
        },
        {
          "bankName": "Länsförsäkringar Bank",
          "bankId": "0040"
        },
        {
          "bankName": "Nordea (NB)",
          "bankId": "0050"
        },
        {
          "bankName": "SEB",
          "bankId": "0070"
        },
        {
          "bankName": "SkandiaBanken",
          "bankId": "0080"
        },
        {
          "bankName": "Sparbanken Syd",
          "bankId": "0090"
        },
        {
          "bankName": "Swedbank",
          "bankId": "0110"
        },
        {
          "bankName": "Ålandsbanken",
          "bankId": "0120"
        },
        {
          "bankName": "Marginalen Bank",
          "bankId": "0140"
        }
      ]
    },
    "/elements/my-profile/invoice-settings/payment/register/einvoice": {
      "POST": [
        {
          "bankName": "Länsförsäkringar Bank",
          "bankId": "0040"
        }
      ]
    },
    "/elements/outage-subscription-dialog/customer/outage-information": {
      "GET": [
        {
          "displayNotification": true,
          "emailAddress": "hello@hello.com",
          "mobileNumber": "0790000000"
        }
      ],
      "PUT": [
        {
          "$value": true
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/heat-consumption": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "consumption": {
            "value": 0.424,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "consumption": {
            "value": 0.455,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "consumption": {
            "value": 0.432,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "consumption": {
            "value": 0.546,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "consumption": {
            "value": 0.697,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "consumption": {
            "value": 0.7,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "consumption": {
            "value": 0.696,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "consumption": {
            "value": 0.789,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "consumption": {
            "value": 0.695,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "consumption": {
            "value": 0.754,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "consumption": {
            "value": 0.695,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "consumption": {
            "value": 0.694,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "consumption": {
            "value": 0.798,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "consumption": {
            "value": 0.852,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "consumption": {
            "value": 0.709,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "consumption": {
            "value": 0.703,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "consumption": {
            "value": 0.877,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "consumption": {
            "value": 0.965,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "consumption": {
            "value": 1.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "consumption": {
            "value": 1.456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "consumption": {
            "value": 1.132,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "consumption": {
            "value": 1.042,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "consumption": {
            "value": 0.845,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "consumption": {
            "value": 0.702,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 1,
          "consumption": {
            "value": 11.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 2,
          "consumption": {
            "value": 8.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 3,
          "consumption": {
            "value": 9.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 4,
          "consumption": {
            "value": 7.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 5,
          "consumption": {
            "value": 11.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 6,
          "consumption": {
            "value": 12.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 7,
          "consumption": {
            "value": 15.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 1525,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1445,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1410,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 1048,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 656,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 484,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 778,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 1045,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 1185,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1425,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 985,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "consumption": {
            "value": 0.424,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "consumption": {
            "value": 0.455,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "consumption": {
            "value": 0.432,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "consumption": {
            "value": 0.546,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "consumption": {
            "value": 0.697,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "consumption": {
            "value": 0.7,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "consumption": {
            "value": 0.696,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "consumption": {
            "value": 0.789,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "consumption": {
            "value": 0.695,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "consumption": {
            "value": 0.754,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "consumption": {
            "value": 0.695,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "consumption": {
            "value": 0.694,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "consumption": {
            "value": 0.798,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "consumption": {
            "value": 0.852,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "consumption": {
            "value": 0.709,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "consumption": {
            "value": 0.703,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "consumption": {
            "value": 0.877,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "consumption": {
            "value": 0.965,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "consumption": {
            "value": 1.456,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "consumption": {
            "value": 1.132,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "consumption": {
            "value": 1.042,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "consumption": {
            "value": 0.845,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "consumption": {
            "value": 0.702,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 1,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 2,
          "consumption": {
            "value": 0.823,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 3,
          "consumption": {
            "value": 0.983,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 4,
          "consumption": {
            "value": 0.723,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 5,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 6,
          "consumption": {
            "value": 2.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 7,
          "consumption": {
            "value": 5.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 133,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 145,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 140,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 104,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 65,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 48,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 56,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 66,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 77,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 104,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 118,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 142,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 124,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 121,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 84,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 28,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 25,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 30,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 58,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 84,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 95,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 663,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 12,
          "consumption": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1225,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1045,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1010,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 648,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 256,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 678,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 645,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 445,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 1,
          "consumption": {
            "value": 36,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 2,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 3,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 4,
          "consumption": {
            "value": 32,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 5,
          "consumption": {
            "value": 36,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 6,
          "consumption": {
            "value": 38,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 7,
          "consumption": {
            "value": 39,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 31,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 34,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 31,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 27,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 26,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 32,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 27,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 38,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/heat-wac-consumption": {
      "GET": [
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "consumption": {
            "value": 0.424,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "consumption": {
            "value": 0.455,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "consumption": {
            "value": 0.432,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "consumption": {
            "value": 0.546,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "consumption": {
            "value": 0.697,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "consumption": {
            "value": 0.7,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "consumption": {
            "value": 0.696,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "consumption": {
            "value": 0.789,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "consumption": {
            "value": 0.695,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "consumption": {
            "value": 0.754,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "consumption": {
            "value": 0.695,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "consumption": {
            "value": 0.694,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "consumption": {
            "value": 0.798,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "consumption": {
            "value": 0.852,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "consumption": {
            "value": 0.709,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "consumption": {
            "value": 0.703,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "consumption": {
            "value": 0.877,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "consumption": {
            "value": 0.965,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "consumption": {
            "value": 1.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "consumption": {
            "value": 1.456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "consumption": {
            "value": 1.132,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "consumption": {
            "value": 1.042,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "consumption": {
            "value": 0.845,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "consumption": {
            "value": 0.702,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 1,
          "consumption": {
            "value": 11.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 2,
          "consumption": {
            "value": 8.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 3,
          "consumption": {
            "value": 9.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 4,
          "consumption": {
            "value": 7.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 5,
          "consumption": {
            "value": 11.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 6,
          "consumption": {
            "value": 12.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "day": 7,
          "consumption": {
            "value": 15.123,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 1525,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1445,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1410,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 1048,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 656,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 484,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 778,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 1045,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 1185,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1425,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 985,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2023-01-01",
          "_toDate": "2023-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Energy",
          "year": 2023,
          "month": 1,
          "consumption": {
            "value": 744,
            "unit": "MWH"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 0,
          "consumption": {
            "value": 0.424,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 1,
          "consumption": {
            "value": 0.455,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 2,
          "consumption": {
            "value": 0.432,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 3,
          "consumption": {
            "value": 0.546,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 4,
          "consumption": {
            "value": 0.697,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 5,
          "consumption": {
            "value": 0.7,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 6,
          "consumption": {
            "value": 0.696,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 7,
          "consumption": {
            "value": 0.789,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 8,
          "consumption": {
            "value": 0.695,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 9,
          "consumption": {
            "value": 0.754,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 10,
          "consumption": {
            "value": 0.695,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 11,
          "consumption": {
            "value": 0.694,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 12,
          "consumption": {
            "value": 0.798,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 13,
          "consumption": {
            "value": 0.852,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 14,
          "consumption": {
            "value": 0.709,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 15,
          "consumption": {
            "value": 0.703,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 16,
          "consumption": {
            "value": 0.877,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 17,
          "consumption": {
            "value": 0.965,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 18,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 19,
          "consumption": {
            "value": 1.456,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 20,
          "consumption": {
            "value": 1.132,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 21,
          "consumption": {
            "value": 1.042,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 22,
          "consumption": {
            "value": 0.845,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Hourly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "day": 31,
          "hour": 23,
          "consumption": {
            "value": 0.702,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 1,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 2,
          "consumption": {
            "value": 0.823,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 3,
          "consumption": {
            "value": 0.983,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 4,
          "consumption": {
            "value": 0.723,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 5,
          "consumption": {
            "value": 1.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 6,
          "consumption": {
            "value": 2.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "day": 7,
          "consumption": {
            "value": 5.123,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 152,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 145,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 140,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 104,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 65,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 48,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 56,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 66,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 77,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 104,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 118,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 142,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 124,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 121,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 84,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 28,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 25,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 30,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 45,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 58,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 84,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Flow",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 95,
            "unit": "M3"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 1425,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 1245,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 1210,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 848,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 456,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 250,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 306,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 456,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 578,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 845,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2021,
          "month": 12,
          "consumption": {
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 1225,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 1045,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 1010,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 648,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 256,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 284,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 450,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 506,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 656,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 678,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 645,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "Cost",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 445,
            "unit": "SWEDISH_KRONA"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 1,
          "consumption": {
            "value": 36,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 2,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 3,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 4,
          "consumption": {
            "value": 32,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 5,
          "consumption": {
            "value": 36,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 6,
          "consumption": {
            "value": 38,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_resolution": "Daily",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "day": 7,
          "consumption": {
            "value": 39,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 1,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 2,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 3,
          "consumption": {
            "value": 31,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 4,
          "consumption": {
            "value": 34,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 5,
          "consumption": {
            "value": 31,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 6,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 7,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 8,
          "consumption": {
            "value": 27,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 9,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 10,
          "consumption": {
            "value": 26,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 11,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2021-01-01",
          "_toDate": "2021-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2021,
          "month": 12,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 1,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 2,
          "consumption": {
            "value": 29,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 3,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 4,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 5,
          "consumption": {
            "value": 32,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 6,
          "consumption": {
            "value": 28,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 7,
          "consumption": {
            "value": 27,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 8,
          "consumption": {
            "value": 30,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 9,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 10,
          "consumption": {
            "value": 38,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 11,
          "consumption": {
            "value": 37,
            "unit": "CELSIUS"
          }
        },
        {
          "$array": true,
          "_premiseId": "*",
          "_fromDate": "2022-01-01",
          "_toDate": "2022-12-31",
          "_resolution": "Monthly",
          "_consumptionType": "DeltaT",
          "year": 2022,
          "month": 12,
          "consumption": {
            "value": 33,
            "unit": "CELSIUS"
          }
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/heat-start-date": {
      "GET": [
        {
          "$value": 1609459200,
          "_premiseId": "*"
        }
      ]
    },
    "/elements/my-consumption/premises/:premiseId/power-of-attorney": {
      "GET": [
        {
          "_premiseId": "*",
          "signingUrl": "https://www.signing-service.com/signing/000000",
          "status": "inactive"
        }
      ],
      "PUT": [
        {
          "_premiseId": "*",
          "signingUrl": "https://www.signing-service.com/signing/000000",
          "status": "pending-signature"
        }
      ]
    }
  }
}
